<template>Random Artist Component</template>

<script>
export default {
  name: "RandomArtist",
};
</script>

<style scoped></style>
